const healthMap = new Map();

healthMap.set("Calories",                               0);
healthMap.set("Protein",                                2);
healthMap.set("Carbohydrate",                          0.1);
healthMap.set("Dietary Fiber",                          1.5);
healthMap.set("Soluble Fiber",                          1.5);
healthMap.set("Insoluble Fiber",                        2);
healthMap.set("Total Sugars",                           -1);
healthMap.set("Other Carbs",                            -0.2);
healthMap.set("Fat",                                    -0.5);
healthMap.set("Saturated Fat",                          -2);
healthMap.set("Mono Fat",                               1);
healthMap.set("Poly Fat",                               1);
healthMap.set("Trans Fatty Acid",                       -5);
healthMap.set("Cholesterol",                            -1);
healthMap.set("Water",                                  1);
healthMap.set("Vitamin A - IU",                         1);
healthMap.set("Vitamin A - RE",                         1);
healthMap.set("Beta-Carotene",                          1);
healthMap.set("Vitamin B1",                             1);
healthMap.set("Vitamin B2",                             1);
healthMap.set("Vitamin B3",                             1);
healthMap.set("Vitamin B3 - Niacin Equiv",              1);
healthMap.set("Vitmin B6",                              1);
healthMap.set("Vitamin B12",                            1);
healthMap.set("Biotin",                                 1);
healthMap.set("Vitamin C",                              1);
healthMap.set("Vitamin D - IU",                         1);
healthMap.set("Vitamin D - mcg", 1);
healthMap.set("Vitamin D (D2 + D3), International Units",   1);
healthMap.set("Vitamin E - Alpha-Toco Equiv",           1);
healthMap.set("Vitamin E - IU",                         1);
healthMap.set("Folate",                                 1);
healthMap.set("Vitamin K",                              1);
healthMap.set("Pantothenic Acid",                       1);
healthMap.set("Calcium Ca",                                2);
healthMap.set("Chloride",                               1);
healthMap.set("Chromium",                               1);
healthMap.set("Copper",                                 1);
healthMap.set("Iodine",                                 1);
healthMap.set("Iron, Fe",                                   1);
healthMap.set("Magnesium",                              1);
healthMap.set("Manganese",                              1);
healthMap.set("Molybdenum",                             1);
healthMap.set("Phosphorus",                             1);
healthMap.set("Potassium",                              1);
healthMap.set("Protein",                                2);
healthMap.set("Selenium",                               1);
healthMap.set("Sodium",                                 1);
healthMap.set("Zinc",                                   1);
healthMap.set("Iron",                                   1);
healthMap.set("18:0 - Stearic",                         -0.5);
healthMap.set("18:2 - Linoleic",                        -1);
healthMap.set("18:3 - Linolenic",                       1);
healthMap.set("Omega 3 Fatty Acid",                     2);
healthMap.set("Omega 6 Fatty Acid", 2);
healthMap.set("Fatty acids, total trans",                     2);
healthMap.set("Fatty acids, total saturated",                     2);
healthMap.set("Alcohol",                                -1);
healthMap.set("Sugar Alcohol",                          1);
healthMap.set("Choline",                                1);
healthMap.set("Vitamin E - Alpha-Toco",                 1);
healthMap.set("Added Sugar",                            -2);
healthMap.set("Unsaturated Fat",                        -0.2);
healthMap.set("Folate, food",                           1);
healthMap.set("Folate, DFE",                            1);
healthMap.set("Vitamin A - RAE",                        1);
healthMap.set("Vitamin A, IU", 1);
healthMap.set("EU Carbohydrate",                        -0.2);
healthMap.set("Salt",                                   -0.1);
healthMap.set("Dietary Fiber (2016)",                   1);
healthMap.set("Soluble Fiber (2016)",                   1);
healthMap.set("Insoluble Fiber (2016)",                 1);
healthMap.set("Non-digestible Carbohydrates",           1);
healthMap.set("Soluble Non-digestible Carbohydrates",   1);
healthMap.set("Insoluble Non-digestible Carbohydrates", 1);
healthMap.set("MyPlate - Fruit",                        1);
healthMap.set("MyPlate - Dairy",                        1);
healthMap.set("MyPlate - Grain Total",                  1);
healthMap.set("MyPlate = Vegetable Total",              1);
healthMap.set("MyPlate - Protein Total", 2);
healthMap.set("Protein",                                2);
healthMap.set("Exchange - Fruit",                       1);
healthMap.set("Exchange - Other Carbs",                 1);
healthMap.set("Exchange - Starch",                      1);
healthMap.set("Exchange - Vegetables",                  1);
healthMap.set("Exchange - Fat",                         1);
healthMap.set("Exchange - Alcohol",                     -1);
healthMap.set("Exchange - NonFat Milk",                 1);
healthMap.set("Exchange - Lean Meat",                   1);
healthMap.set("Gram Weight",                            0);
healthMap.set("Calories from Fat",                      -0.5);
healthMap.set("Calories from SatFat",                   -1);
healthMap.set("Total lipid (fat)",                      -0.5);
healthMap.set("Sodium, Na",                             -0.1);
healthMap.set("Carbohydrate, by difference",            -0.1);
healthMap.set("Energy",                                   2);
healthMap.set("Nonfat Milk",                              1);
healthMap.set("Fiber, total dietary", 2);






// Protein health.js:96
// undefined health.js:97
// Total lipid (fat) health.js:96
// undefined health.js:97
// Carbohydrate, by difference health.js:96
// undefined health.js:97
// Energy health.js:96
// undefined health.js:97
// Sodium, Na

export function getHealthValue(Ingredient) {
    
    let score = 0;
    for (let nutrient of Ingredient.foodNutrients) {
      const weight = healthMap.get(nutrient.nutrientName);
      let value = nutrient.value;
      if (nutrient.unitName === "MG") {
        value /= 1000;
      }
      if (nutrient.unitName === "UG") {
        value /= 1000000;
      }
      if (weight) {
        score += (value * weight);
      }
    }
    
    console.log(Ingredient.description + ": " + score);
    score += 50;
    if (score < 0) {
        score = 0;
    }
    if (score > 100) {
        score = 100;
    }
    score = Math.round(score);
    return score;
}

